import { SectionWrapper } from '../components/SectionWrapper';

import examPerformanceUrl from '@/images/ai_exam_performance.png';
import styles from './HeadlineFindingSection.module.css';

const PAPER_URL = 'https://journals.aps.org/prper/abstract/10.1103/v93w-ytyc';

export function HeadlineFindingSection() {
  return (
    <SectionWrapper background="white" data-testid="research-section-finding">
      <div className={styles.section}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>THE HEADLINE FINDING</p>
          <h2 className={styles.title}>
            The students who needed help the most got the most benefit.
          </h2>
          <p className={styles.body}>
            Controlling for incoming physics understanding (measured by Force
            Concept Inventory score) and other variables, students who
            completed the supplemental math assignment scored higher on
            subsequent exams. The effect was largest on the third exam - the
            exam most aligned with the supplemental material.
          </p>
          <p className={styles.body}>
            Crucially, the effect was strongest for students who entered the
            course with weaker math preparation. Black, Hispanic and Latine,
            Native American, and lower-income students disproportionately
            benefit, because they&apos;re statistically less likely to have had
            access to advanced math courses in high school.
          </p>
          <figure className={styles.pullQuote}>
            <blockquote>
              &quot;Using AI tools can remove social barriers that prevent
              students from asking instructors, teaching assistants, and/or
              peers for help.&quot;
            </blockquote>
            <figcaption>
              - Yifan Lu, lead author, UCLA Physics & Astronomy
            </figcaption>
          </figure>
          <a
            className={styles.link}
            href={PAPER_URL}
            rel="noopener noreferrer"
            target="_blank"
          >
            Read the full paper in Phys. Rev. PER ↗
          </a>
        </div>

        {/* The paper's own figure, as /ai shows it: the page draws no chart. */}
        <figure className={styles.figure}>
          <img
            alt="Figure 6 from Lu et al. (2025): exam 2 score against Force Concept Inventory score. Students who used AI hints scored higher, most of all those with the lowest inventory scores; the two lines meet near the top."
            className={styles.chart}
            height={1444}
            loading="lazy"
            src={examPerformanceUrl}
            width={1476}
          />
          <figcaption>
            Figure 6 from Lu et al. (2025): exam 2 score against Force Concept
            Inventory score, separated by use of AI hints. The colored bands
            show 95% confidence intervals.
          </figcaption>
        </figure>
      </div>
    </SectionWrapper>
  );
}
